import '../stitches.config.js';

const isDarkTheme = (theme) => {
    return !!(theme === null || theme === void 0 ? void 0 : theme.toLowerCase().includes('dark'));
};

export { isDarkTheme };
